export function CaseStudy() {
  return (
    <section aria-labelledby="case-study-heading">
      <h2 className="section-heading" id="case-study-heading">
        Caso de estudio
      </h2>
      <ol>
        <li>
          <strong>Problema:</strong> los contratos suelen documentar respuestas felices pero dejan sin
          cubrir autenticación, conflicto, límites y dependencias.
        </li>
        <li>
          <strong>Restricción:</strong> demostrarlo sin VPS, sin datos privados y sin dependencia
          permanente de un tercero.
        </li>
        <li>
          <strong>Decisión:</strong> aplicación estática — TypeScript en el navegador, procesamiento
          pesado en Web Worker y persistencia local opcional. No existe backend público ni datos que
          salgan del dispositivo.
        </li>
        <li>
          <strong>Prueba:</strong> acción pública reproducible, fixtures adversariales, contratos JSON
          Schema y una suite de pruebas unitarias, de contrato, de integración y E2E.
        </li>
        <li>
          <strong>Resultado:</strong> solo se publican métricas obtenidas después de pruebas reales; no se
          afirman cifras no medidas.
        </li>
      </ol>
      <p>
        Repositorio: <a href="https://github.com/Aredex/rest-failure-matrix">github.com/Aredex/rest-failure-matrix</a>
      </p>
    </section>
  );
}
